export enum InputType {
  Text = 'Text',
  Email = 'Email',
  Number = 'Number',
  Password = 'Password',
  Tel = 'Tel',
  URL = 'URL'
}
